import React from 'react';
import { LockFill } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';

/** Shared accent for lockout-active banners and Active status pills. */
export function getLockoutBannerAccent(colors) {
  return colors?.danger || '#F73263';
}

/**
 * Soft lockout notice: icon left, title + description stacked.
 * Intentionally calm — border accent without heavy fills or glow.
 */
export default function LockoutActiveBanner({ endsAtText, style }) {
  const { colors } = useTheme();
  const accent = getLockoutBannerAccent(colors);

  const description = endsAtText
    ? `You cannot place new trades, but you can close existing positions. Lockout ends at ${endsAtText}.`
    : 'You cannot place new trades, but you can close existing positions.';

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        marginBottom: 16,
        padding: '12px 14px',
        borderRadius: 10,
        border: `1px solid ${accent}66`,
        backgroundColor: `${accent}10`,
        color: colors.text,
        ...style,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          flexShrink: 0,
          width: 32,
          height: 32,
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: `${accent}18`,
          border: `1px solid ${accent}40`,
          marginTop: 1,
        }}
      >
        <LockFill size={14} style={{ color: accent }} />
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            fontSize: '0.875rem',
            fontWeight: 600,
            color: colors.text,
            letterSpacing: '0.01em',
            lineHeight: 1.3,
          }}
        >
          Lockout Active
        </div>
        <div
          style={{
            marginTop: 4,
            fontSize: '0.8125rem',
            lineHeight: 1.45,
            color: colors.textMuted || colors.textLight,
          }}
        >
          {description}
        </div>
      </div>
    </div>
  );
}
